var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-third-vendors-detail',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"pt-third-vendors-detail__withData",attrs:{"vendor":_vm.currentVendor}})}
var staticRenderFns = []

export { render, staticRenderFns }